import * as types from '../constants/ActionTypes';

export const initialState = {
    homeworkId: [],
    disableFavouriteEditorialHomework: false
};

export default function favouriteEditorialHomework(state = initialState, action = {}) {
    switch (action.type) {
        case types.ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_SUCCESS:
            return {
                ...state,
                homeworkId: action.result
            };
        case types.ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_FAILURE:
            return {
                ...state
            };
        case types.REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_SUCCESS:
            return {
                ...state,
                homeworkId: action.result
            };
        case types.REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_FAILURE:
            return {
                ...state
            };
        case types.GET_FAVOURITE_EDITORIAL_HOMEWORK:
            return {
                ...state,
                disableFavouriteEditorialHomework: false
            };
        case types.GET_FAVOURITE_EDITORIAL_HOMEWORK_SUCCESS:
            return {
                ...state,
                homeworkId: action.result,
                disableFavouriteEditorialHomework: false
            };
        case types.GET_FAVOURITE_EDITORIAL_HOMEWORK_FAILURE:
            return {
                ...state,
                disableFavouriteEditorialHomework: true
            };
        default:
            return state;
    }
}
